/**
 * Email validation error codes
 */
export const EMAIL_VALIDATION_ERROR = {
  EMPTY: 'EMAIL_EMPTY',
  INVALID_FORMAT: 'INVALID_EMAIL_FORMAT',
} as const;
